// @flow
import React, {useMemo} from 'react';
import Box from "@mui/material/Box";
import useUserData from "../../../../../../../hooks/user/useUserData";
import {muiGridLocales} from "../../../../../../../helpers/muiGridLocales";
import {DataGridPremium, GridToolbar} from "@mui/x-data-grid-premium";
import {formatDate} from "../../../../../../../helpers/date";
import { reportGridsSx } from "../../helpers";

type Props = {};

const VisitsTotal = (props: Props) => {
	const {loading, data, t, generalReport} = props
	const {language, dateFormat} = useUserData()
	
	const columns = useMemo(() => [
			...(generalReport ? [{
				field: 'exhibition',
				description: t('Exhibition'),
				headerName: t('Exhibition'),
				minWidth: 200,
				flex: 1
			}] : []),
			...(generalReport ? [{
				field: 'coorganization',
				description: t('Coorganization'),
				headerName: t('Coorganization'),
				minWidth: 200,
				flex: 1
			}] : []),
			{
				field: 'exhibitionStartDt',
				description: t('Exhibition Date'),
				headerName: t('Exhibition Date'),
				flex: 1,
				minWidth: 180,
				valueFormatter: (value, row, column, apiRef) => {
					return `${formatDate(value, dateFormat)}`
				}
			},
			{
				field: 'entranceLobby1Count',
				description: t('EntranceLobby1Count'),
				headerName: t('EntranceLobby1Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceLobby2Count',
				description: t('EntranceLobby2Count'),
				headerName: t('EntranceLobby2Count'),
				minWidth: 180,
				flex: 1,
				type: 'number',
			},
			{
				field: 'entranceLoungeCount',
				description: t('EntranceLoungeCount'),
				headerName: t('EntranceLoungeCount'),
				minWidth: 180,
				flex: 1,
				type: 'number',
			},
			{
				field: 'entranceEvent1Count',
				description: t('EntranceEvent1Count'),
				headerName: t('EntranceEvent1Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent2Count',
				description: t('EntranceEvent2Count'),
				headerName: t('EntranceEvent2Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent3Count',
				description: t('EntranceEvent3Count'),
				headerName: t('EntranceEvent3Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent4Count',
				description: t('EntranceEvent4Count'),
				headerName: t('EntranceEvent4Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent5Count',
				description: t('EntranceEvent5Count'),
				headerName: t('EntranceEvent5Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceCount',
				description: t('EntranceCount'),
				minWidth: 180,
				headerName: t('EntranceCount'),
				flex: 1,
				type: 'number',
			},
			{
				field: 'visitorCount',
				description: t('VisitorCount'),
				minWidth: 220,
				headerName: t('VisitorCount'),
				flex: 1,
				type: 'number',
			},
		],
		[dateFormat, generalReport, t]
	)
	return (
		<Box style={{height: 600, width: '100%'}}>
			<DataGridPremium
				sx={reportGridsSx}
				loading={loading}
				initialState={{
					density: "standard"
				}}
				localeText={muiGridLocales(language)}
				rows={data}
				columns={columns}
				slotProps={{toolbar: {csvOptions: {disableToolbarButton: true}}}}
				slots={{
					toolbar: GridToolbar
				}}
			/>
		</Box>
	);
};

export default VisitsTotal